import React from 'react';
import { withStyles } from 'material-ui/styles';
import List, { ListItem, ListItemText } from 'material-ui/List';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';
import Typography from 'material-ui/Typography';
import CloseIcon from 'material-ui-icons/Close';
import Handlers from './handlers.js';

const styles = {
  root:{
    height: '100%',
  },
  appBar: {
    position: 'relative',
  },
  list: {
    overflow : 'scroll',
    height: '85%',
  },
  flex: {
    flex: 1,
  },
};

class HandlersDialogRendererStep extends React.Component {
  constructor(props){
    super(props);
    this.handleSelected = this.handleSelected.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
  }

  handleSelected(selection){
    if(this.props.onSelected)
      this.props.onSelected(selection);
  }

  handleRequestClose(){
    if(this.props.onClose){
      this.props.onClose();
    }
  }

  render() {
    var key = 0;
    const classes = this.props.classes;
    var handlers = new Handlers(); 
    const items = handlers.getRenderers();
    return (
      <div className={classes.root}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="contrast" onClick={this.handleRequestClose} aria-label="Close">
                <CloseIcon />
              </IconButton>
              <Typography type="title" color="inherit" className={classes.flex}>
                Renderers
              </Typography>
            </Toolbar>
          </AppBar>
          <List className={classes.list}>
            {items.map(item =>
              <ListItem key={key++} button onClick={this.handleSelected.bind(this, item)}>
                <ListItemText primary={item.name}/>
              </ListItem>
            )}
          </List>
      </div>
    );
  }
}

export default withStyles(styles)(HandlersDialogRendererStep);


// WEBPACK FOOTER //
// ./src/search/admin/handlers_dialog_renderer_step.js